(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cardHoverVideoInit) return;
    window.__cardHoverVideoInit = true;

    var isTouch = window.matchMedia('(hover: none)').matches;
    var io = null;

    function load(v) {
      if (v.dataset.loaded || !v.dataset.src) return;
      v.src = v.dataset.src;
      v.dataset.loaded = '1';
    }
    function activate(v) {
      load(v);
      v.classList.add('is-active');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    function deactivate(v, reset) {
      v.classList.remove('is-active');
      v.pause();
      if (reset) {
        try { v.currentTime = 0; } catch (e) {}
      }
    }

    if (isTouch && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            activate(entry.target);
          } else {
            deactivate(entry.target, false);
          }
        });
      }, { threshold: [0, 0.6] });
    }

    function scan() {
      document.querySelectorAll('[data-card-hover-video]').forEach(function (video) {
        if (video.dataset.bound) return;
        video.dataset.bound = '1';
        if (isTouch) {
          if (io) io.observe(video);
        } else {
          var gallery = video.closest('.card-gallery');
          if (!gallery) return;
          gallery.addEventListener('mouseenter', function () { activate(video); });
          gallery.addEventListener('mouseleave', function () { deactivate(video, true); });
        }
      });
    }

    scan();
    document.addEventListener('DOMContentLoaded', scan);
    window.setTimeout(scan, 1000);
    document.addEventListener('shopify:section:load', scan);
  })();
  } catch(e) { console.error(e); }
})();

})();
